import { render, staticRenderFns } from "./MontagemCargaForm.vue?vue&type=template&id=0162081a"
import script from "./MontagemCargaForm.vue?vue&type=script&lang=js"
export * from "./MontagemCargaForm.vue?vue&type=script&lang=js"
import style0 from "./MontagemCargaForm.vue?vue&type=style&index=0&id=0162081a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports